export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return
  const host = window.location.hostname
  if (host.endsWith('.netlify.app')) {
    const target = `https://kendrick.paris${window.location.pathname}${window.location.search}`
    window.location.replace(target)
  }
})
